var utils = require('frontend-controller/lib/utils');

module.exports = {
	events: {
		editLiterature: {
			type: 'click',
			selector: '.icon.edit',
			action: function(event){
				var self = event.data.component;
				event.stopImmediatePropagation();
				event.preventDefault();
				var $target = $(event.target).closest('div.icon.edit')
				var literatureID = $target.data('id')

				if(literatureID){
					self.triggerClosest('showEdit_literature', { literatureID: literatureID });
				}
			}
		},
		deleteLiterature: {
			type: 'click',
			selector: '.icon.delete',
			action: function(event){
				var self = event.data.component;
				event.stopImmediatePropagation();
				event.preventDefault();
				var $target = $(event.target).closest('div.icon.delete')
				var literatureID = $target.data('id')

				if(literatureID){
					self.triggerClosest('delete_literature', { literatureID: literatureID });
				}
			}
		}
	},

	model: {
		visibleLiteratureIDs: {}
	},

	methods: {
		getResourceFilters: function(){
			return this.model.resourceFilters;
		},

		sanitizeResources: function(storage){
			var self = this;
			self.model.visibleLiteratureIDs = {};
			var resourceFilters = self.model.resourceFilters || {};
			var literatureID;
			if(!utils.isEmpty(resourceFilters.search) || !utils.isEmpty(resourceFilters.listOfCategoryDataIDs)){
				utils.forEach((self.resourceData.literatureCategoryFilter || {}).data || [], function(categoryData){
					if((literatureID = (categoryData || {}).entityID)){
						self.model.visibleLiteratureIDs[literatureID] = true;
					}
				});
			}

			var userLoggedIn = storage.user.hasAccessTo('loggedIn', 'common');
			if(userLoggedIn){
				self.model.nrOfVisibleElements = utils.collectionSize(self.model.visibleLiteratureIDs || []);
				self.model.nrOfElements = utils.collectionSize(self.resourceData.data || []);
			} else {
				self.model.nrOfVisibleElements = 0;
				self.model.nrOfElements = 0;
			}

			utils.forEach(self.resourceData.data || [], function(literature, dataIndex){
				if(!userLoggedIn){
					self.model.nrOfElements++;
					if(self.model.visibleLiteratureIDs[literature.attributes[literature.primaryKey]]){
						self.model.nrOfVisibleElements++;
					}
				}
			});
		}
	},

	hooks: {
		filterChanged: function($element, options){
			this.model.resourceFilters = {
				search: 				(options || {}).search || '',
				listOfCategoryDataIDs: 	(options || {}).listOfCategoryDataIDs
			};

			if(!this.model.resourceFilters.search && utils.collectionSize(this.model.resourceFilters.listOfCategoryDataIDs) <= 0){
				this.resourceData = {};
				this.model.nrOfVisibleElements = 0;
				this.model.nrOfElements = 0;
				this.refresh(false);
			} else {
				this.refresh(true);
			}
		},

		onRefresh: function($element, options){
			this.model.resourceFilters = {};
			this.refresh();
		}
	}
}